// Add your custom JS here.
// if you're using a bundler, first import:
import Headroom from "headroom.js";
import {
    gsap
} from "gsap";

import ScrollMagic from "scrollmagic";
import 'owl.carousel';
import $ from "jquery";
import "./lottie";
import { initHeroAnimation, initStaticHeroIntro } from "./kkg-hero";
import { initStatementLines } from "./kkg-statement-lines";
import { initGalleries } from "./kkg-gallery";
import { initFooterCredit } from "./kkg-footer";
import { initBookingLink } from "./kkg-booking";


/* The following plugin is a Club GSAP perk */
import {
    ScrollSmoother
} from "gsap/ScrollSmoother";

import {
    ScrollTrigger
} from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollSmoother);




// grab an element
var myElement = document.querySelector("html");
var options = {
    // vertical offset in px before element is first unpinned
    offset: {
        up: 150,
        down: 150
    },
    // or you can specify tolerance individually for up/down scroll
    tolerance: {
        up: 100,
        down: 100
    },

    onUnpin: function () {
        document.querySelector('.dropdown-menu').classList.remove('show');
    },

}
// construct an instance of Headroom, passing the element

var headroom = new Headroom(myElement, options);
// initialise
headroom.init();

ScrollSmoother.create({
    smooth: 1.5,
    effects: true,
});


// Navigation 
document.addEventListener("DOMContentLoaded", function (event) {

    // Startseiten-Header-Animation (Logo + Bogen-Bild -> Sticky-Menü)
    initHeroAnimation({ headroom: headroom });
    // Startseite: statischer Header mit Lottie-Intro (Seite gesperrt), danach automatisch zum Inhalt scrollen
    initStaticHeroIntro({ headroom: headroom, delay: 3000 });

    // Block Statement Lines: Zeilen bauen sich beim Scrollen auf und rasten magnetisch ein
    initStatementLines();
    // Block Galerie: Bildraster mit Fullscreen-Lightbox (Tastatur, Swipe, Screenreader)
    initGalleries();
    // Footer: „Created by kapelari.studio" wird beim Sichtbarwerden getippt
    initFooterCredit();
    // Kurzlink ?buchen (z. B. E-Mail-Signatur): DIRS21-Buchungsmaske direkt öffnen
    initBookingLink();
    var shareButton = $('.item-object .share-button');
    // shareButton.die("click");
    var shareClose = $('.item-object .close-button');



    $(function () {
        shareButton.on('click', function (e) {
            e.preventDefault();
            if (navigator.share) {
                // console.log('navigator.share');
                navigator.share({
                        title: 'Objekt Teilen',
                        url: $(this).attr("href"),
                    }).then(() => {
                        // console.log($(this).attr("href"));
                        // console.log('Thanks for sharing!');
                    })
                    .catch(console.error);
            } else {
                console.log('navigator.share else');
                if ($(this).parents('.share-item').hasClass('is-open')) {
                    $(this).parents('.share-item').removeClass('is-open');
                } else {
                    $(this).parents('.share-item').addClass('is-open');
                }
            }
        })


        shareClose.on('click', function (e) {
            e.preventDefault();
            var parentShareItem = $(this).closest('.share-item').get(0);

            console.log(parentShareItem);
            parentShareItem.classList.remove('is-open');
            // $(parentShareItem).removeClass('is-open');
            console.log(parentShareItem);

        })
    });


    $('.item-object .copy-link').on('click', function (e) {
        e.preventDefault();
        var copyText = $(this);

        // Select the text field
        var itemUrl = $(copyText).attr('item-url');

        // Copy the text inside the text field
        navigator.clipboard.writeText(itemUrl);

        // Alert the copied text
        console.log("Copied the text: " + itemUrl);
        alert('Link kopiert');
        var parentShareItem = $(this).closest('.share-item').get(0);
        parentShareItem.classList.remove('is-open');

    })



    // Toogle Menu open Class

    // Untermenü des aktuellen Bereichs (z. B. „Region" auf /aktivitaeten/winter/)
    // ist beim Öffnen des Menüs bereits aufgeklappt. WordPress markiert das
    // Eltern-Element mit current-menu-ancestor/-parent; liegt die aktuelle Seite
    // selbst auf einem Elternpunkt, greift current-menu-item.menu-item-has-children.
    function openCurrentSubmenu() {
        var current = document.querySelector(
            '#main-menu > .menu-item.current-menu-ancestor, ' +
            '#main-menu > .menu-item.current-menu-parent, ' +
            '#main-menu > .menu-item.current-menu-item.menu-item-has-children'
        );
        if (!current) {
            return;
        }

        $('#main-menu .dropdown-menu').removeClass('show');
        $('#main-menu .dropdown-toggle').attr('aria-expanded', 'false');

        var submenu = current.querySelector('.dropdown-menu');
        var toggle = current.querySelector('.dropdown-toggle');
        if (submenu) {
            submenu.classList.add('show');
        }
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
        }
    }

    openCurrentSubmenu();

    var navbarNavOffcanvas = document.getElementById('navbarNavOffcanvas')
    navbarNavOffcanvas.addEventListener('show.bs.offcanvas', function () {
        // console.log('fire show');
        var element = document.querySelector("html");
        element.classList.add("menu-open");
        openCurrentSubmenu();

    })


    navbarNavOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
        // console.log('fire hidden');
        var element = document.querySelector("html");
        element.classList.remove("menu-open");
    })


    $('#main-menu > .menu-item').on('mouseenter', function () {
        // Hide Submenu
        $('.menu-item .dropdown-menu').removeClass('show');
        $('.menu-item.dropdown .dropdown-toggle').attr('aria-expanded', 'false');
        // Show Submenu
        $(this).find('.dropdown-menu').first().addClass('show');
        $(this).find('.dropdown-toggle').first().attr('aria-expanded', 'true');
    })

    // Owl-Slider: weichere Übergänge. Owls Standard sind 250 ms mit "ease", das wirkt bei
    // bildschirmbreiten Slides ruckartig. Nach dem Loslassen beim Ziehen etwas kürzer,
    // damit der Slide nicht nachhängt.
    var owlSmoothSpeed = 800;
    var owlSmoothDragEndSpeed = 500;
    var owlSmoothTransition = 'cubic-bezier(0.45, 0, 0.15, 1)';

    // Block Icon Row carousel

    $('.icon-row-owl').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        smartSpeed: owlSmoothSpeed,
        dragEndSpeed: owlSmoothDragEndSpeed,
        slideTransition: owlSmoothTransition,
        responsive: {
            0: {
                items: 1,
                center: true,
            },
            768: {
                items: 2.3
            },
            992: {
                items: 3.3
            },
            1400: {
                items: 5
            }
        }
    })



    //Contact Form
    // JavaScript to be fired on the home page

    $('.float-container input, .float-container textarea').on('focus blur', toggleFocus);

    $('.float-container label').on('click', toggleFocus);

    function toggleFocus(e) {
        //console.log(e.type)

        if (e.type == 'focus') {
            // do something on focus
            $(this).parents('.float-container').addClass('active');
        } else {
            // do something else on blur
            if (!$(this).val()) {
                $(this).parents('.float-container').removeClass('active');
            }
        }
    }


    // Ensure ScrollSmoother is active
    let smoother = ScrollSmoother.get();

    if (!smoother) {
        console.error("ScrollSmoother is not initialized.");
    }


    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        const html = document.querySelector('html');

        console.log('target', target)

        if (target && typeof ScrollSmoother !== "undefined") {
            // console.log(' scrolling', target)

            setTimeout(() => {
                // console.log("this is the second message");
                smoother.scrollTo(target, true, "top top");
                headroom.unpin();
            }, 500);
        }
    }

    $('#main-nav .offcanvas-body .nav-link, .sticky-menu .nav-link').on("click", function (e) {
        const html = document.querySelector('html');

        if (!e.target.href || e.target.getAttribute('href') === '#') {
            console.warn("Href is missing or just '#'.");
            return;
        }


        if (window.location.hash) {
            const target = document.querySelector(window.location.hash);
            console.log('target', target)

            if (target && typeof ScrollSmoother !== "undefined") {
                console.log(' scrolling', target)

                setTimeout(() => {
                    console.log("this is the second message");
                    smoother.scrollTo(target, true, "top top");
                }, 500);
            }
        }

        // setTimeout(() => {
        //     headroom.unpin();
        // }, 500);

        //     var $href = $(this).attr('href'); // Get the href attribute
        //     console.log("Href attribute:", $href);

        //     if (!$href || $href === '#') {
        //         console.log("Href is missing or just '#'.");
        //         return;
        //     }

        //     var isAnchor = $href.startsWith('#'); // Check if it's an internal anchor
        //     console.log("Is anchor:", isAnchor);

        //     var targetElement = isAnchor ? document.querySelector($href) : null;
        //     console.log("Target element:", targetElement);

        // Hide the offcanvas menu
        $('#navbarNavOffcanvas').offcanvas('hide');
        console.log("Offcanvas menu hidden.");

        //     if (isAnchor && targetElement) {
        //         e.preventDefault(); // Prevent default anchor behavior
        //         var spaceToTop = $(window).width() >= 768 ? 100 : 30;
        //         console.log("Space to top:", spaceToTop);

        //         try {
        //             setTimeout(() => {
        //                 smoother.scrollTo(targetElement, true, "top top");

        //             }, 500);
        //             console.log("Scrolling to target element.");
        //         } catch (error) {
        //             console.error("Error during scrolling:", error);
        //         }
        //     } else {
        //         // Navigate normally if it's an external URL
        //         window.location.href = $href;
        //         console.log("Navigating to external URL:", $href);
        //     }
    });












    $(document).on('scroll', function () {
        // console.log($('html').hasClass('headroom--pinned'));
        if ($('html').hasClass('headroom--pinned') && $('html').hasClass('headroom--top')) {
            setTimeout(function () {
                $('#main-nav .navbar-brand ').addClass('show');
            }, 100);
        } else {
            $('#main-nav .navbar-brand ').removeClass('show')
        }
    })

    // MENÜ SCROLL ENDE


    var banner = $('.owl-carousel.banner')

    banner.owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        autoplay: true,
        animateOut: 'fadeOut',
        smartSpeed: owlSmoothSpeed,
        dragEndSpeed: owlSmoothDragEndSpeed,
        slideTransition: owlSmoothTransition,
        dots: true,
        center: false,
        lazyLoad: true,
        autoHeight: false,
        responsive: {
            0: {
                items: 1,
            },
        },
        onInitialized: addAccessibility, // Barrierefreiheit nach Init hinzufügen
        onRefreshed: addAccessibility // Auch nach Refresh anwenden
    })
    var objectCorousel = $('.owl-carousel')

    objectCorousel.owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        autoplay: false,
        smartSpeed: owlSmoothSpeed,
        dragEndSpeed: owlSmoothDragEndSpeed,
        slideTransition: owlSmoothTransition,
        dots: true,
        center: false,
        lazyLoad: true,
        autoHeight: true,
        responsive: {
            0: {
                items: 1,
            },
        },
        onInitialized: addAccessibility, // Barrierefreiheit nach Init hinzufügen
        onRefreshed: addAccessibility // Auch nach Refresh anwenden
    })


    function addAccessibility() {
        $('.owl-nav button').each(function (index) {
            const label = index === 0 ? 'Vorheriges Slide' : 'Nächstes Slide';
            $(this)
                .attr('tabindex', '0')
                .attr('role', 'button')
                .attr('aria-label', label)
                .on('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        $(this).trigger('click');
                    }
                });
        });

        $('.owl-dots button').each(function (index) {
            $(this)
                .attr('tabindex', '0')
                .attr('role', 'button')
                .attr('aria-label', 'Slide ' + (index + 1))
                .on('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        $(this).trigger('click');
                    }
                });
        });
    }

    // Block FAQ Collapse: GSAP animiert die Antwort-Höhe 0 <-> auto
    var faqReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    // Öffnet bzw. schließt eine einzelne Antwort
    function setFaqState(toggle, open) {
        var answer = document.getElementById(toggle.getAttribute("aria-controls"));

        if (!answer) {
            return;
        }

        toggle.setAttribute("aria-expanded", open ? "true" : "false");

        // Nutzer mit reduzierter Bewegung: ohne Animation umschalten
        if (faqReducedMotion.matches) {
            gsap.set(answer, {
                height: open ? "auto" : 0,
                visibility: open ? "visible" : "hidden",
            });
            ScrollTrigger.refresh();
            return;
        }

        if (open) {
            answer.style.visibility = "visible";
            gsap.to(answer, {
                height: "auto",
                duration: 0.45,
                ease: "power2.inOut",
                overwrite: true,
                onComplete: function () {
                    ScrollTrigger.refresh();
                },
            });
        } else {
            gsap.to(answer, {
                height: 0,
                duration: 0.45,
                ease: "power2.inOut",
                overwrite: true,
                onComplete: function () {
                    answer.style.visibility = "hidden";
                    // ScrollSmoother/ScrollTrigger nach Höhenänderung neu vermessen
                    ScrollTrigger.refresh();
                },
            });
        }
    }

    document.querySelectorAll(".faq-collapse .faq-toggle").forEach(function (toggle) {
        if (!document.getElementById(toggle.getAttribute("aria-controls"))) {
            return;
        }

        toggle.addEventListener("click", function () {
            var isOpen = toggle.getAttribute("aria-expanded") === "true";

            // Akkordeon: beim Öffnen alle anderen offenen Fragen im selben Block schließen
            if (!isOpen) {
                toggle.closest(".faq-collapse").querySelectorAll('.faq-toggle[aria-expanded="true"]').forEach(function (other) {
                    if (other !== toggle) {
                        setFaqState(other, false);
                    }
                });
            }

            setFaqState(toggle, !isOpen);
        });
    });


    //Stop Intro

    $('html').on('click', function () {
        // console.log('log');
        if ($('body').hasClass('pace-running')) {
            // console.log('log');
            $('.intro-animation').hide(100)
            setTimeout(function () {
                $('body').addClass('pace-stopped');
            }, 100);
        }

    });





});